import React, { useEffect, useState } from "react";
import Button from "../../atoms/Button/Button";
import LogoutIcon from "@mui/icons-material/Logout";
import FirstLoginForm, {
  UserCreationType,
} from "../../organisms/FirstLoginForm/FirstLoginForm";
import { ArrowBack } from "@mui/icons-material";
import { createUser, deleteUser, getMe } from "../../../services/api/user.api";
import { useDispatch } from "react-redux";
import { setUser, UserType } from "../../../redux/reducers/settingsReducer";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store/store";
import Pricing from "../../organisms/Pricing/Pricing";
import { useTranslation } from "react-i18next";

interface FirstLoginPageProps {
  email: string;
  onUserCreate: (user: UserType) => void;
  onLogout: () => void;
}

const FirstLoginPage = (props: FirstLoginPageProps) => {
  const { email, onLogout, onUserCreate } = props;
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const user = useSelector(
    (state: RootState) => state.settings.user?.subscription
  );

  useEffect(() => {
    if (user === "free") {
      setIsSubscriptionPageOpen(true);
    }
  }, [user]);

  const [isSubscriptionPageOpen, setIsSubscriptionPageOpen] = useState(false);

  const handleCreateAccount = (body: UserCreationType) => {
    createUser(dispatch, body).then((response) => {
      if (response !== undefined && response.result !== null) {
        dispatch(setUser(response.result));
        onUserCreate(response.result);
      }
    });
  };
  const handleBack = () => {
    getMe(dispatch).then((user) => {
      if (user === undefined || user === null) {
        setIsSubscriptionPageOpen(false);
        return;
      }
      if (user.subscription === "free") {
        deleteUser(dispatch).then((response) => {
          if (response !== undefined && response.result === "Done") {
            window.localStorage.removeItem("currentSidebarItem");
            window.localStorage.removeItem("currentTab");
          }
        });
        setIsSubscriptionPageOpen(false);
      } else {
        window.location.reload();
      }
    });
  };

  return (
    <div className="dui-first-login">
      <div className="dui-first-login-form">
        <div className="dui-first-login-logo">
          <b>Doktor</b>UI
        </div>
        <div className="dui-first-login-title">{t("firstLoginTitle")}</div>
        {isSubscriptionPageOpen ? (
          <Pricing />
        ) : (
          <FirstLoginForm
            email={email}
            onUserCreate={handleCreateAccount}
            onLogout={onLogout}
          />
        )}
        <Button
          onClick={() => onLogout()}
          className="dui-first-login-button-sign-out"
          type="text"
          icon={<LogoutIcon />}
        >
          {t("logout")}
        </Button>
        {isSubscriptionPageOpen && (
          <Button
            icon={<ArrowBack />}
            type="text"
            className="dui-first-login-back-button"
            onClick={() => {
              handleBack();
            }}
          />
        )}
      </div>
    </div>
  );
};

export default FirstLoginPage;
